import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import { Card, CardContent, Grid } from '@mui/material';

import { useFetchInitMgmtLeasesPayments } from './hooks'

import { PaymentsFilter } from './PaymentsFilter'
import { InfoContract } from './InfoContract'
import { PaymentsTable } from './PaymentsTable'
import { ModalModule } from './ModalModule'

export const LeasesPayments = (props) => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFetchInitMgmtLeasesPayments({location, paramsURL})

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        // Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    // ------------------------------------------------ globalStates
    const { showForm } = globalStates
    // ------------------------------------------------ Helpers
    // ------------------------------------------------ Formularios
    // ------------------------------------------------ FetchData
    // ------------------------------------------------ Actions

    return (
        <AllowedAccess permissions={['97_ARRENDAMIENTOS_PAGOS']} renderAuthFailed={<p>Error</p>}>
            <div className="content">
                <ModalModule useFetchInit={useFetchInit} />
                {(!showForm) && (
                    <>
                        <div className="panel-body">
                            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Card style={{zIndex:'1'}}>
                                        <CardContent>
                                            
                                            <div className='h4 mt-1 mb-1'> Pagos de arrendamientos</div>
                                            <div className="border-bottom border-dark"></div>
                                            {/* {loadingFetchAllClients && ( <LinearLoading /> )} */}

                                            <div className="pt-4"></div>
                                            <div className="pt-4"></div>
                                            <div className="text-dark"> <i className="fa-solid fa-filter"></i> Filtro de búsqueda</div>
                                            <div className="border-bottom border-dark"></div>
                                            <div className="pt-3"></div>

                                            <PaymentsFilter useFetchInit={useFetchInit}/>
                                            <InfoContract useFetchInit={useFetchInit}/>

                                            <div className="pt-4"></div>
                                            <div className="pt-4"></div>
                                            <div className="text-dark"> <i className="fa-solid fa-money-bill-wave"></i> Control de pagos</div>
                                            <div className="border-bottom border-dark"></div>
                                            <div className="pt-3"></div>

                                            <PaymentsTable useFetchInit={useFetchInit}/>

                                            <div className="pt-4"></div>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </div>
                    </>
                )}
                {(showForm) && (
                    <>
                        <div className="panel-body">
                            {/* <FormUser useFetchInit={useFetchInit} /> */}
                        </div>
                    </>
                )}
            </div>
        </AllowedAccess>
    )
}
